import React, { useMemo } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

export default function RichEditor({ value, onChange, placeholder }) {
  const modules = useMemo(() => ({
    toolbar: [
      [{ header: [2, 3, false] }],
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['blockquote', 'link'],
      ['clean'],
    ],
  }), []);

  const formats = ['header', 'bold', 'italic', 'underline', 'list', 'bullet', 'blockquote', 'link'];

  return (
    <div className="pm-quill">
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        placeholder={placeholder || 'Start writing...'}
        modules={modules}
        formats={formats}
      />
    </div>
  );
}
